import { formatDateTime } from '../../../utils/DateFormatters';
import StatusBadge from './StatusBadge';

const determineLink = (page, endpoints) => {
  const { editDynamicPageUrl, editCategoryValueUrl } = endpoints;

  if (page.is_dynamic_page) {
    return editDynamicPageUrl.replace(':id', page.id);
  }
  if (page.parent_category_id) {
    return editCategoryValueUrl.replace(':category_id', page.parent_category_id).replace(':category_name', page.parent_category_name).replace(':id', page.id);
  }
  if (page.is_from_sitemap) {
    return `/_sf/admin/content/editor?path=/${page.url_slug}`;
  }
  return null;
};

export default function RowOptions({ page, endpoints, isSimple, isPlaceholder, handleAddPage }) {
  const { currentDomain, duplicateUrl, editDynamicPageTemplateUrl, editJobUrl } = endpoints;
  const { is_from_sitemap: isFromSitemap, parent_category_id: isPoweredByCategory, is_dynamic_page: isDynamicPage, is_job: isJob } = page;

  const editLink = determineLink(page, endpoints);
  const updatedAt = page.updated_at;
  const fullUrl = page.url_slug;
  const fullTitle = page.title;
  const dynamicPageTemplate = page.dynamic_page_template;

  const pathToVisit = page.url_slug === '/' ? '' : page.url_slug;

  const handleItemClick = (event) => {
    event.stopPropagation();
  };

  const handleDuplicate = (page) => {
    const { id } = page;

    window.location.href = duplicateUrl.replace(':id', id);
  };

  return (
    <div className="dp-row-option-full">
      <StatusBadge {...{ page }} />
      <div className="dropdown">
        <button className="btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          <i className="fe fe-info" />
        </button>
        <ul className="dropdown-menu" style={{ width: 330 }}>
          {dynamicPageTemplate && (
            <>
              <li onClick={handleItemClick}>
                <div className="dropdown-item-text d-flex flex-column gap-2">
                  <strong className="mb-0 user-select-none">Powered by template</strong>
                  <p className="mb-0">{dynamicPageTemplate.title}</p>
                </div>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
            </>
          )}
          <li onClick={handleItemClick}>
            <div className="dropdown-item-text d-flex flex-column gap-2">
              <strong className="mb-0 user-select-none">Title</strong>
              <p className="mb-0 user-select-auto">{fullTitle}</p>
            </div>
          </li>
          <li>
            <hr className="dropdown-divider" />
          </li>
          <li onClick={handleItemClick}>
            <div className="dropdown-item-text d-flex flex-column gap-2">
              <strong className="mb-0 user-select-none">Full URL</strong>
              <p className="mb-0 user-select-auto text-break">{fullUrl}</p>
            </div>
          </li>
          {updatedAt && (
            <>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li onClick={handleItemClick}>
                <div className="dropdown-item-text d-flex flex-column gap-2">
                  <strong className="mb-0 user-select-none">Updated at</strong>
                  <p className="mb-0">{formatDateTime(updatedAt)}</p>
                </div>
              </li>
            </>
          )}
        </ul>
      </div>
      <div className="dropdown">
        <button className="btn" type="button" data-bs-toggle="dropdown" aria-expanded="false">
          <i className="fe fe-more-horizontal" />
        </button>
        <ul className="dropdown-menu">
          <li>
            <a
              aria-disabled={!isFromSitemap}
              className={`dropdown-item d-flex align-items-center gap-2 ${!isFromSitemap ? 'disabled' : ''}`}
              target="_blank"
              rel="noopener noreferrer"
              href={`${currentDomain}${pathToVisit}`}
            >
              View <i className="fe fe-external-link" /> {!isFromSitemap && <span className="text-muted fs-5">(not live)</span>}
            </a>
          </li>
          {isJob && (
            <li>
              <a className="dropdown-item" rel="noopener noreferrer" href={editJobUrl.replace(':id', page.id)}>
                Edit job
              </a>
            </li>
          )}
          {dynamicPageTemplate && (
            <li>
              <a className="dropdown-item" rel="noopener noreferrer" href={editDynamicPageTemplateUrl.replace(':id', dynamicPageTemplate.id)}>
                Edit template
              </a>
            </li>
          )}
          {editLink && (
            <li>
              <a className="dropdown-item" rel="noopener noreferrer" href={editLink} target={!isDynamicPage && !isPoweredByCategory ? '_blank' : undefined}>
                Edit{' '}
                {isDynamicPage ? (
                  <span>builder page</span>
                ) : isPoweredByCategory ? (
                  <span>category value</span>
                ) : (
                  <span>
                    using on-page editor <i className="fe fe-external-link" />
                  </span>
                )}
              </a>
            </li>
          )}
          {isDynamicPage && (
            <li>
              <button className="dropdown-item" type="button" onClick={() => handleDuplicate(page)}>
                Duplicate builder page
              </button>
            </li>
          )}
          <li>
            <hr className="dropdown-divider" />
          </li>
          {!isDynamicPage && (
            <li>
              <button className="dropdown-item" type="button" onClick={() => handleAddPage(page, true)}>
                {isPlaceholder ? 'Create new Builder page' : 'Replace with Builder page'}
              </button>
            </li>
          )}
          {handleAddPage && (
            <li>
              <button className="dropdown-item" type="button" onClick={() => handleAddPage(page)}>
                Add new child Builder page
              </button>
            </li>
          )}
          <li>
            <hr className="dropdown-divider" />
          </li>
          <li>
            <div className="d-flex gap-2 text-muted px-3 py-2">
              <i className="fe fe-info" />
              <span>
                {isPoweredByCategory
                  ? 'This page is powered by a category value.'
                  : isDynamicPage
                  ? 'This page is powered by a Builder page.'
                  : 'This page is powered by the codebase.'}
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>
  );
}
